import { styled } from '@mui/material/styles'
import { type Environment, getEnvironment } from '../utils/getEnvironment'

const getBackgroundStyle = (env: Environment): string => {
  if (env === 'local') {
    return 'linear-gradient(120deg, #595959 25%, #8c8c8c 25%, #8c8c8c 50%, #595959 50%, #595959 75%, #8c8c8c 75%, #8c8c8c 100%)'
  } else if (env === 'development') {
    return 'linear-gradient(120deg, #8734cf 25%, #a462de 25%, #a462de 50%, #8734cf 50%, #8734cf 75%, #a462de 75%, #a462de 100%)'
  } else if (env === 'staging') {
    return 'linear-gradient(120deg, #ff6600 25%, #fa8e46 25%, #fa8e46 50%, #ff6600 50%, #ff6600 75%, #fa8e46 75%, #fa8e46 100%)'
  } else {
    return ''
  }
}

const environment = getEnvironment()

const Banner = styled('div')({
  backgroundImage: getBackgroundStyle(environment),
  backgroundSize: '10.00px 17.32px',
  color: 'white',
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '15px',
  boxSizing: 'border-box',
  padding: '2px',
  textTransform: 'uppercase',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1rem',
  fontWeight: 'bold',
  zIndex: 1300,
})

export default function EnvironmentBanner() {
  if (environment === 'production') {
    return null
  }

  return <Banner>{environment}</Banner>
}
